export default __webpack_public_path__ + "static/media/fn_withus1.f908e2b6.png";